import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  patients: [],
  error: null,
  isLoading: false,
};

const patientsSlice = createSlice({
  name: 'patients',
  initialState,
  reducers: {
    setPatients: (state, action) => {
      state.patients = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setPatients, setError, setIsLoading } = patientsSlice.actions;

export const selectAllPatients = (state) => state.patients.patients;

export default patientsSlice.reducer;
